import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from '@angular/core';
import { ButtonComponent, ButtonDisplayStyle } from '@workbuddy/ui/v2/components/button';

export interface ConfirmationCardField {
  key: string;
  label: string;
  value: string;
  previousValue?: string;
  isLong: boolean;
}

export interface ConfirmationCardContextItem {
  label: string;
  detail?: string;
}

@Component({
  selector: 'agent-confirmation-card',
  standalone: true,
  imports: [ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.disabled]': '$disabled()',
    '(keydown.enter)': 'onApprove()',
    'tabindex': '0',
    'role': 'region',
    '[attr.aria-label]': '$title()',
  },
  templateUrl: './confirmation.card.component.html',
  styleUrls: ['./confirmation.card.component.less'],
})
export class AgentConfirmationCardComponent {

  protected ButtonDisplayStyle = ButtonDisplayStyle;

  public $title = input.required<string>({ alias: 'title' });
  public $context = input<ConfirmationCardContextItem[]>([], { alias: 'context' });
  public $reasoning = input<string>('', { alias: 'reasoning' });
  public $fields = input<ConfirmationCardField[]>([], { alias: 'fields' });
  public $disabled = input<boolean>(false, { alias: 'disabled' });

  public approve = output<void>();
  public decline = output<void>();

  public onApprove(): void {

    if (this.$disabled()) return;
    this.approve.emit();
  }

  public onDecline(): void {

    if (this.$disabled()) return;
    this.decline.emit();
  }
}
